<template>
  <v-card max-width="600">
    <v-toolbar
      color="primary"
      dark
    >
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="body-2">Outfox AI is the easiest way to fundraise and get your message out to your supporters!</div>
      <div class="body-1">Please choose your advertiser type:</div>
      <v-container
        fluid
        grid-list-md
      >
        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex xs5>
            <v-flex
              xs12
              d-flex
            >
              <v-card
                color="primary"
                dark
                class="py-5 pointer"
                ripple
              >
                <div
                  @click="nextPage('political_campaign')"
                  class="text-uppercase text-xs-center subheading"
                >Political Campaign</div>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              d-flex
            >
              <v-card
                text
                class="py-5"
                color="grey lighten-3"
              >
                <div
                  class="text-uppercase text-xs-center blue--text text--darken-4 subheading"
                >Non-Profit</div>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              d-flex
            >
              <v-card
                text
                class="py-5"
                color="grey lighten-3"
              >
                <div
                  class="text-uppercase text-xs-center blue--text text--darken-4 subheading"
                >Commercial</div>
              </v-card>
            </v-flex>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'TheWelcomeSecondPage',
    props: {
      title: {
        type: String,
        default: 'Welcome to Outfox AI'
      }
    },
    methods: {
      nextPage (advertiser) {
        this.$emit('setAdvertiserType', advertiser)
      }
    }
  }
</script>

<style scoped>

</style>
